import React, {useRef} from 'react';

import Logo from '../img/TWT-logo.svg';
import MobileLogo from '../img/twt-logo-mobile.svg';
import NZONAIRLOGO from '../img/PIJ-logo.svg'


const Title =()=> {
      const scrollToHere = useRef(null);
      // const goToViolation=(id)=>{
      //   scrollToHere.current.scrollIntoView({ behavior: "smooth", block: "start" });
      // };
       return (
         <React.Fragment>
          <div className="stuffHeader-titlecontainer">
            <div className="stuffHeader-titlecontainer--introbox">
            <img className="stuffHeader-titlecontainer--introbox---logo" src={Logo} alt="the whole truth te marmatanga logo"/>
            <img className="stuffHeader-titlecontainer--introbox---logo--mobile" src={MobileLogo} alt="the whole truth te marmatanga logo"/>
            {/* <p className="stuffHeader-titlecontainer--introbox---text">
            Short, fact-checked posts and videos on the health and&#160;well&#8209;being&#160;of&#160;all&#160;New&#160;Zealanders.
            </p> */}
            <p className="stuffHeader-titlecontainer--introbox---text">
            Short, fact-checked posts and videos on the health and well&#8209;being of all New&#160;Zealanders.
            </p>
            {/* <span className="stuffHeader-titlecontainer--introbox---button" onClick={goToViolation}>Learn more</span> */}
            </div>
          </div>
          <div 
          className="stuffHeader-introcontainer"
          ref={scrollToHere}
          >
            <div className="stuffHeader-introcontainer--introbox">
              
                <p className="stuffHeader-introcontainer--introbox---text">
                Social media is awash with medical misinformation. Falsehoods spread faster than facts, and the health and well-being of people can suffer as a result.
                </p>
                <p className="stuffHeader-introcontainer--introbox---text">
                This is our response.
                </p>
                <p className="stuffHeader-introcontainer--introbox---text">
                <i>The Whole Truth: Te Māramatanga</i> explains public health topics prone to misinformation. It seeks to inform rather than inflame. 
                </p>
                <p className="stuffHeader-introcontainer--introbox---text">
                Through the short stories, videos and graphics on this page, you’ll find information on a range of topics to do with the health and well-being of New Zealanders. We cover things that are especially prone to myths, misinformation and half-truths. Our work is carefully researched, reviewed by a panel of independent experts and designed to help you understand things better.
                </p>
                <p className="stuffHeader-introcontainer--introbox---text">To ensure we reach as many New Zealanders as possible, the videos are captioned in English, te reo Māori, Samoan and Tongan.</p>
                <p className="stuffHeader-introcontainer--introbox---text">
                It’s a big job, made possible - in part - by funding from NZ On Air’s Public Interest Journalism Fund. The money we receive from this fund is used to pay the animators, presenters, translators and the expert advisory panel who work with us. The journalism is independent and created according to Stuff’s <a className="stuffHeader-introcontainer--introbox---a" href="https://www.stuff.co.nz/about-stuff/300106664/stuff-editorial-code-of-practice-and-ethics" target="_top">code of ethics</a>. All editorial decisions, from panel appointments to topics we cover, are made by Stuff editors without influence from any external sources.
                </p>
                <div className="stuffHeader-introcontainer--introbox---nzonairbox">
                  <span>Public Interest Journalism funded through NZ On Air</span>
                  <img src={NZONAIRLOGO} alt="NZonAir logo"></img>
                </div>
            </div>
          </div>
          </React.Fragment>
       );
}

export default Title;